export default __webpack_public_path__ + "static/media/suitcase.25f29569.png";